import { useLanguage } from '../../../context/LanguageContext';

const LockIcon = ({ className }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
    </svg>
);

const TEXTS = {
    fr: {
        title: 'Contenu Premium',
        examMessage: 'Cet examen fait partie du contenu payant.',
        courseMessage: 'Ce cours fait partie du contenu payant.',
        freeInfo: 'Vous pouvez accéder gratuitement à certains examens de chaque niveau.',
        upgradeBtn: 'Débloquer l\'accès',
        cancelBtn: 'Retour'
    },
    en: {
        title: 'Premium Content',
        examMessage: 'This exam is part of paid content.',
        courseMessage: 'This course is part of paid content.',
        freeInfo: 'You can access some exams from each level for free.',
        upgradeBtn: 'Unlock Access',
        cancelBtn: 'Go Back'
    }
};

/**
 * UpgradeBlockingModal - Displayed when user tries to access paid content
 *
 * @param {boolean} isOpen - Whether the modal is visible
 * @param {function} onClose - Callback when modal is closed
 * @param {string} levelVar - The level var (e.g., 'ppl', 'cpl')
 * @param {string} contentType - 'exam' or 'course'
 * @param {function} onUpgrade - Callback to open subscription modal
 */
const UpgradeBlockingModal = ({
    isOpen,
    onClose,
    levelVar,
    contentType = 'exam',
    onUpgrade
}) => {
    const { language } = useLanguage();
    const texts = TEXTS[language] || TEXTS.fr;

    if (!isOpen) return null;

    const handleUpgrade = () => {
        onClose();
        if (onUpgrade) {
            onUpgrade(levelVar);
        }
    };

    return (
        <div
            className="fixed inset-0 z-[120] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
            onClick={onClose}
        >
            <div
                className="bg-white dark:bg-gray-900 rounded-3xl max-w-md w-full p-8 text-center shadow-2xl"
                onClick={e => e.stopPropagation()}
            >
                {/* Lock icon */}
                <div className="w-20 h-20 bg-amber-100 dark:bg-amber-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
                    <LockIcon className="w-10 h-10 text-amber-600 dark:text-amber-400" />
                </div>

                <h2 className="text-2xl font-black text-gray-900 dark:text-white mb-4">
                    {texts.title}
                </h2>

                <p className="text-gray-600 dark:text-gray-400 mb-2">
                    {contentType === 'exam' ? texts.examMessage : texts.courseMessage}
                </p>

                <p className="text-sm text-gray-500 dark:text-gray-500 mb-8">
                    {texts.freeInfo}
                </p>

                <div className="flex gap-3">
                    <button
                        onClick={onClose}
                        className="flex-1 py-3 px-4 border-2 border-gray-200 dark:border-gray-700 rounded-xl font-bold text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
                    >
                        {texts.cancelBtn}
                    </button>
                    <button
                        onClick={handleUpgrade}
                        className="flex-1 py-3 px-4 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl font-bold hover:from-blue-700 hover:to-blue-800 transition-all shadow-lg hover:shadow-xl"
                    >
                        {texts.upgradeBtn}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UpgradeBlockingModal;
